<template>
  <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" v-on:input="$emit('updateDialog', false)" max-width="600">
    <v-card>
      <v-card-title>Incrementar precios</v-card-title>
      <v-card-text>
        <div class="row">
          <div class="col-md-12">
            <h6 style="color:black" class="mb-0">Seleccionaste {{ selected.length }} {{ selected.length == 1 ? "tarifa" : "tarifas" }}</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <v-text-field
              label="Porcentaje a aumentar"
              v-model="porcentage"
              type="number"
              suffix="%"
              name="porcentaje"
              data-vv-as="porcentaje"
              v-validate="'required|decimal|min_value:0.01'"
            ></v-text-field>
            <span class="red--text">{{ errors.first("porcentaje") }}</span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text @click="$emit('updateDialog', false)" color="red">Cerrar</v-btn>
        <v-btn text :loading="loading" @click="confirm()" color="green">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    selected: Array,
    service: Object,
  },
  data() {
    return {
      porcentage: "",
      loading: false,
    };
  },
  watch: {
    dialog() {
      this.porcentage = "";
      this.errors.clear();
    },
  },
  methods: {
    confirm() {
      this.$validator.validateAll().then((result) => {
        if (!result || this.loading) return;

        this.loading = true;
        this.service
          .incrementPrice({ ids: this.selected.map((element) => element.id), porcentage: this.porcentage })
          .then((response) => {
            if (response.status === false) {
              this.$toast.error(response.msg || "Ocurrió un error", "Error");
              return;
            }
            this.$toast.success("Se incrementaron los precios", "OK");
            this.$emit("updateDialog", false);
            this.$emit("loadList");
          })
          .catch((e) => {
            console.log(e);
            this.$toast.error("Ocurrió un error", "Error");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>
